module.exports = __webpack_public_path__ + "static/media/man w.beer-bw.90b2593e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/man w.beer-bw.jpg
// module id = 421
// module chunks = 0